/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdTeacherThumbnail200,
  GetApiV1PersonIdTeacherThumbnail401,
  GetApiV1PersonIdTeacherThumbnail404,
  GetApiV1PersonIdTeacherThumbnail500,
  GetApiV1PersonIdTeacherThumbnailPathParams,
  GetApiV1PersonIdTeacherThumbnailQueryResponse,
} from "../../types/personTeacherController/GetApiV1PersonIdTeacherThumbnail.ts";

export const getApiV1PersonIdTeacherThumbnailPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdTeacherThumbnailPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdTeacherThumbnail200Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdTeacherThumbnail200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdTeacherThumbnail401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdTeacherThumbnail401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdTeacherThumbnail404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdTeacherThumbnail404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdTeacherThumbnail500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdTeacherThumbnail500>;

export const getApiV1PersonIdTeacherThumbnailQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdTeacherThumbnail200Schema,
) as unknown as ToZod<GetApiV1PersonIdTeacherThumbnailQueryResponse>;
